module.exports = __webpack_public_path__ + "images/error-icon-2_K0MS1.svg";